// tslint:disable:no-any

import { DisplayDepth, DisplayMixPressure, DisplaySac, DisplayTemp, DisplayWeight } from './Display';

export const convertDiveDataToDisplay = (dive: any) => {
    if (dive.diveAndMixes.dive.weight) {
        dive.diveAndMixes.dive.weight = DisplayWeight.getValue(dive.diveAndMixes.dive.weight);
    }
    if (dive.diveAndMixes.dive.surfaceTemp) {
        dive.diveAndMixes.dive.surfaceTemp = DisplayTemp.getValue(dive.diveAndMixes.dive.surfaceTemp);
    }
    if (dive.diveAndMixes.dive.visibility) {
        dive.diveAndMixes.dive.visibility = DisplayDepth.getValue(dive.diveAndMixes.dive.visibility);
    }

    if (dive.diveAndMixes.mixes.length > 0) {
        dive.diveAndMixes.mixes = dive.diveAndMixes.mixes.map((key: any, index: number) => {
            let mixToConfirm = dive.diveAndMixes.mixes[index];

            if (mixToConfirm.tankVolume) {
                mixToConfirm.tankVolume = DisplaySac.getValue(mixToConfirm.tankVolume);
            }
            if (mixToConfirm.startPressure) {
                mixToConfirm.startPressure = DisplayMixPressure.getValue(mixToConfirm.startPressure);
            }
            if (mixToConfirm.endPressure) {
                mixToConfirm.endPressure = DisplayMixPressure.getValue(mixToConfirm.endPressure);
            }

            return mixToConfirm;
        });
    }
    return (dive);
};

export const convertDiveDataToSave = (diveData: any) => {
    if (diveData.dive.weight) {
        diveData.dive.weight = DisplayWeight.getValueReverse(diveData.dive.weight);
    }
    if (diveData.dive.surfaceTemp) {
        diveData.dive.surfaceTemp = DisplayTemp.getValueReverse(diveData.dive.surfaceTemp);
    }
    if (diveData.dive.visibility) {
        diveData.dive.visibility = DisplayDepth.getValueReverse(diveData.dive.visibility);
    }

    if (diveData.mixes.length > 0) {
        diveData.mixes = diveData.mixes.map((key: any, index: number) => {
            let mixToConfirm = diveData.mixes[index];

            if (mixToConfirm.tankVolume) {
                mixToConfirm.tankVolume = DisplaySac.getValueReverse(mixToConfirm.tankVolume);
            }
            if (mixToConfirm.startPressure) {
                mixToConfirm.startPressure = DisplayMixPressure.getValueReverse(mixToConfirm.startPressure);
            }
            if (mixToConfirm.endPressure) {
                mixToConfirm.endPressure = DisplayMixPressure.getValueReverse(mixToConfirm.endPressure);
            }

            return mixToConfirm;
        });
    }
    return (diveData);
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DiveData.tsx